/**
 * OveflowEvent Types
 */
export enum OverflowEventMode {
  PRE_EVENT = 'preEvent',
  EVENT = 'event',
  POST_EVENT = 'postEvent',
}
